import csvFiles from "api/csv_files/csv_files";
import enterprises from "api/enterprises/enterprises";
import groupCategoryTypes from "api/group_category_types/group_category_types";
import groups from "api/groups/groups";
import outcomes from "api/outcomes/outcomes";
import resources from "api/resources/resources";
import sessions from "api/sessions/sessions";
import user from "api/user/user";
import users from "api/users/users";
import views from "api/views/views";

const Api = {
  enterprises,
  users,
  user,
  sessions,
  groups,
  groupCategoryTypes,
  outcomes,
  resources,
  csvFiles,
  views,
};

export default Api;
